// Treatment session modes
export const [SLEEP, ANXIETY, PAIN, AWAKENING] = ['sleep', 'anxiety', 'pain', 'awakening']

export const daysOfWeekMap = new Map([
  [0, 'sunday'],
  [1, 'monday'],
  [2, 'tuesday'],
  [3, 'wednesday'],
  [4, 'thursday'],
  [5, 'friday'],
  [6, 'saturday'],
])
